import Score from './score';

export default {
	Score,
};
